import GoogleCallback from '../spa/google/GoogleCallback';
import Home from '../spa/Home';
import Marketplace from '../spa/marketplace/index';
import Login from '../spa/login/Login';
import PartnerIntegration from '../spa/partnerIntegrations/Profile';
import Impersonate from '../spa/Impersonate';
import AccountList from '../spa/account/AccountList';
import CreateOrEditAccount from '../spa/account/AccountForm';
import UserList from '../spa/user/UserList';
import CreateOrEditUser from '../spa/user/UserForm';
import DistributionList from '../spa/distribution/DistributionList';
import CreateOrEditDistribution from '../spa/distribution/DistributionForm';
import DomainList from '../spa/domain/DomainList';
import CreateOrEditDomain from '../spa/domain/DomainForm';
import PlaylistList from '../spa/playlist/PlaylistList';
import CreateOrEditPlaylist from '../spa/playlist/PlaylistForm';
import License from '../spa/license/list';
import CreateOrEditLicense from '../spa/license/LicenseForm';
import Series from '../spa/serie/SerieList';
import CreateOrEditSerie from '../spa/serie/SerieForm';
import MediaItem from '../spa/mediaItem/MediaItemList';
import CreateOrEditMediaItem from '../spa/mediaItem/MediaItemForm';
import MediaItemSource from '../spa/mediaSource/MediaSourceList';
import CreateOrEditMediaItemSource from '../spa/mediaSource/MediaSourceForm';
import Billing from '../spa/reporting/Billing';
import NewBilling from '../spa/reporting/NewBilling';
import Reports from '../spa/reporting/Reports';
import Domains from '../spa/reporting/Domains';
import UserActivity from '../spa/activity/UserActivity';
import NotFound from '../spa/NotFound';

export const routes = [
  {
    path: '/google/OAuthCallback',
    component: GoogleCallback
  },
  {
    path: '/',
    component: Home,
    children: [
      /**
        MARKETPLACE
       */
      {
        name: 'Marketplace',
        path: '',
        component: Marketplace,
        alias: 'marketplace'
      },
      {
        path: '/login',
        component: Login
      },
      {
        name: 'Logout',
        path: '/logout',
        beforeEnter() {
          localStorage.setItem('logout', true);
          window.document.location = '/';
          return;
        }
      },
      /**
       * PARTNER INTEGRATIONS
       */
      {
        name: 'PartnerIntegration',
        path: 'partnerIntegrations',
        component: PartnerIntegration
      },
      /**
       * ADMIN IMPERSONATE
       */
      {
        name: 'Impersonate',
        path: 'impersonate',
        component: Impersonate
      },
      /**
       * ACCOUNT
       */
      {
        name: 'AccountList',
        path: 'accounts',
        component: AccountList
      },
      {
        name: 'CreateAccount',
        path: 'account/new',
        component: CreateOrEditAccount
      },
      {
        name: 'EditAccount',
        path: 'account/:id',
        component: CreateOrEditAccount
      },
      /**
       * USER
       */
      {
        name: 'UserList',
        path: 'user',
        component: UserList
      },
      {
        name: 'CreateUser',
        path: 'user/new',
        component: CreateOrEditUser
      },
      {
        name: 'EditUser',
        path: 'user/:id',
        component: CreateOrEditUser
      },

      /**
      DISTRIBUTION
      */
      {
        name: 'DistributionList',
        path: 'distribution',
        component: DistributionList
      },
      {
        name: 'CreateDistribution',
        path: 'distribution/new',
        component: CreateOrEditDistribution
      },
      {
        name: 'EditDistribution',
        path: 'distribution/:id/edit',
        component: CreateOrEditDistribution
      },
      /**
      DOMAINLIST
      */
      {
        name: 'DomainList',
        path: 'domain-list/',
        component: DomainList
      },
      {
        name: 'CreateDomainList',
        path: 'domain-list/new',
        component: CreateOrEditDomain
      },
      {
        name: 'EditDomainList',
        path: 'domain-list/:id',
        component: CreateOrEditDomain
      },
      /**
      PLAYLISTS
      */
      {
        name: 'Playlists',
        path: 'playlist',
        component: PlaylistList
      },
      {
        name: 'CreatePlaylist',
        path: 'playlist/new',
        component: CreateOrEditPlaylist
      },
      {
        name: 'EditPlaylist',
        path: 'playlist/:id',
        component: CreateOrEditPlaylist
      },
      /**
      LICENSES
      */
      {
        name: 'LicenseList',
        path: 'license',
        component: License
      },
      {
        name: 'CreateLicense',
        path: 'license/new',
        component: CreateOrEditLicense
      },
      {
        name: 'EditLicense',
        path: 'license/:id',
        component: CreateOrEditLicense
      },
      /**
      SERIES
      */
      {
        name: 'Series',
        path: 'serie',
        component: Series
      },
      {
        name: 'CreateSerie',
        path: 'serie/new',
        component: CreateOrEditSerie
      },
      {
        name: 'EditSerie',
        path: 'serie/:id',
        component: CreateOrEditSerie
      },
      /**
      MEDIA ITEM
      */
      {
        name: 'Videos',
        path: 'video',
        component: MediaItem
      },
      {
        name: 'CreateVideo',
        path: 'video/new',
        component: CreateOrEditMediaItem
      },
      {
        name: 'EditVideo',
        path: 'video/:id',
        component: CreateOrEditMediaItem
      },
      /**
      MEDIA SOURCE
      */
      {
        name: 'VideoSources',
        path: 'video-source',
        component: MediaItemSource
      },
      {
        name: 'CreateVideoSource',
        path: 'video-source/new',
        component: CreateOrEditMediaItemSource
      },
      {
        name: 'EditVideoSource',
        path: 'video-source/:id',
        component: CreateOrEditMediaItemSource
      },
      /**
      REPORTING
       */
      {
        name: 'Billing',
        path: 'reports/billing',
        component: Billing
      },
      {
        name: 'NewBilling',
        path: 'reports/new-billing',
        component: NewBilling
      },
      {
        name: 'Reports',
        path: 'reports/views',
        component: Reports
      },
      {
        name: 'Domains',
        path: 'reports/domains',
        component: Domains
      },
      {
        name: 'UserLogsList',
        path: 'activity',
        component: UserActivity
      }
    ]
  },
  {
    name: 'NotFound',
    path: '/404',
    alias: '*',
    component: NotFound
  }
];

export const VueRouterObject = {
  routes,
  mode: 'history',
  saveScrollPosition: true,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
};

export default VueRouter => new VueRouter(VueRouterObject);



// WEBPACK FOOTER //
// ./src/config/router.js